import Box from '@mui/material/Box';
import type { BoxProps } from '@mui/material';
import { topMenuLayoutTestIds } from './TopMenuLayout.test-ids';

export function TopMenu({ children, ...props }: { children: React.ReactNode } & BoxProps) {
  return (
    <Box
      data-testid={topMenuLayoutTestIds.topMenu}
      width="100%"
      display="flex"
      flexDirection="column"
      zIndex={9}
      lineHeight="unset"
      {...props}
      sx={{ position: 'sticky', top: 0, height: 'var(--header-height)', ...props.sx }}
    >
      {children}
    </Box>
  );
}

export function TopMenuRow({ children, ...props }: { children: React.ReactNode } & BoxProps) {
  return (
    <Box
      data-testid={topMenuLayoutTestIds.topMenuRow}
      width="100%"
      display="flex"
      gap={2}
      justifyContent="space-between"
      alignItems="center"
      {...props}
      sx={{ paddingVertical: 'sm', paddingHorizontal: 'xl', ...props.sx }}
    >
      {children}
    </Box>
  );
}

export function TopMenuLeft({ children, ...props }: { children: React.ReactNode } & BoxProps) {
  return (
    <Box
      data-testid={topMenuLayoutTestIds.topMenuLeft}
      display="flex"
      flexDirection="column"
      flexWrap="nowrap"
      flexShrink={1}
      flexGrow={0}
      {...props}
    >
      {children}
    </Box>
  );
}

export function TopMenuRight({ children, ...props }: { children: React.ReactNode } & BoxProps) {
  return (
    <Box
      data-testid={topMenuLayoutTestIds.topMenuRight}
      display="flex"
      alignItems="center"
      gap={2}
      justifyContent="flex-end"
      flexWrap="nowrap"
      flexShrink={0}
      flexGrow={0}
      {...props}
    >
      {children}
    </Box>
  );
}
